<template>
  <div id="app">
    <LogHeader :userValue="user" :token="token" :statusLoader="runningProcess" @getUser="handleUser" @getToken="handleToken" @getToggle="hdlToggle" @getDynamics="hdlDynamics" @change="handleChange"/>
    <LoadAnimation v-show="loading" class="loadform" :loadSettings="loadSettings" />
    <DeploymentStatus v-show="deploymentWindow" :deploymentInfo="deploymentInfo" @closeWindow="hldcloseDeployment" />
    <transition name="fade" >
      <div class="exception-wrapper" v-show="exceptionsList.showExceptions">
          <oExceptions :value="exceptionsList" @getCloseException="hdlCLoseException" />
      </div>
    </transition>
    <transition name="slide" mode="out-in" appear>
      <keep-alive exclude="BxRegisterForm">
        <router-view v-if="user" :dynamics="dynamics" :userValue="user" :token="token" :value="value" :disable="disable" @change="handleChange" @getToken="handleToken" @getUser="handleUser" @disableInput="hdldisable" @getDeployType="hdlDeployType" @gethybrid="hdlhybrid" @getLoad="hdlLoad" @getDeploymentInfo="hdlDeploymentInfo" @getExceptions="hdlExceptions"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import BxRegisterForm from './components/BxRegisterForm'
import BxRegisterVNext from './components/BxRegisterVNext'
import LogHeader from './components/LogHeader'
import BxList from './components/BxList'
import LoadAnimation from './components/LoadAnimation'
import DeploymentStatus from './components/DeploymentStatus'
import oExceptions from './components/oExceptions'
require('@/assets/css/common.css');

export default {
  name: 'App',
  components: {
    BxRegisterForm,
    BxRegisterVNext,
    LogHeader,
    BxList,
    LoadAnimation,
    DeploymentStatus,
    oExceptions
  },
  data() {
    return {
      dynamics: '',
      user: this.user || null,
      token: this.token || null,
      value: this.value || {
        hybridConnection: false,
        hybridConnectionHost: '',
        hybridConnectionPort: 0,
        appControlMergeFile: 'App.NAV.WS.xml?{DebugLog}=false;{FormsTestSite}=false;{PurchaseDisabled}=true;{UseNAVSSOEmailing}=true',
        formsTestSitePassword: '',
        authentication: '',
        dynamics: '',
        deployType: 'npe'
      },
      disable: false,
      loading: false,
      loadSettings: this.loadSettings || {
        animationStyle: 'slide',
        message: 'This may take a while..',
      },
      deploymentWindow: false,
      deploymentInfo:[],
      status:{
        deploymentStatusUrl: '',
        correlationId: ''
      },
      exceptionsList: {
        exceptions:[],
        showExceptions: false
      }
    }
  },
  created() {
    if (sessionStorage) {
      if (sessionStorage.getItem('formvalue')) {
        this.value = JSON.parse(sessionStorage.getItem('formvalue'))
      }
      if (sessionStorage.getItem('disable')) {
        this.disable = JSON.parse(sessionStorage.getItem('disable'))
      }
      if (sessionStorage.getItem('dynamics')) {
        this.dynamics = JSON.parse(sessionStorage.getItem('dynamics'))
      }
      if (sessionStorage.getItem('deploymentInfo')) {
        this.deploymentInfo = JSON.parse(sessionStorage.getItem('deploymentInfo'))
        this.deploymentInfo.forEach(i => {
          if (i.status == 'Processing' || i.status == 'Running') {
            this.hdlJobId(i)
          }
        })
      }
    }
  },
  watch: {
    value(v) {
      sessionStorage.setItem('formvalue', JSON.stringify(v))
    },
    disable(v) {
      sessionStorage.setItem('disable', JSON.stringify(v))
    },
    user(u) {
      sessionStorage.setItem('user', JSON.stringify(u))
    },
  },
  computed: {
    runningProcess() {
      if (this.deploymentInfo.length > 0) {
        return this.deploymentInfo.some(j => {
          if (j.status == 'Processing' || j.status == 'Running') {
            return true
          }
        })
      } else return false
    },
  },
  methods: {
    hdlDeployType(v){
      this.value.deployType = v ? 'prod' : 'npe' 
    },
    hdlCLoseException(){
      this.exceptionsList.showExceptions = false;
    },
    hdlExceptions(v){
      this.$http('api/register/exceptions', 'POST', this.token, v).then(resp => {
                this.loading = false
                this.exceptionsList.exceptions = resp.exceptions
                this.exceptionsList.showExceptions = true;
              })
              .catch(e => {
                if (e.status === 401) {
                  this.loading = false
                  this.$emit('getUser', '')
                  this.$emit('getToken', '')
                  sessionStorage.clear()
                  this.$toasted.global.error_login(
                    'You are not Authorized. Token might have expired. Please log in again'
                  )
                }else{
                  console.log(e)
                  this.loading = false
                  this.$toasted.global.error_message()
                }
              })
    },
    hdlDynamics(v){
      this.value.appControlMergeFile = (v.dynamics == 'FO') ? 'App.AX.WS.xml?{ax365api1}=true;{Lines.EditQty}=false;{UseDebugLog}=false;{FormsTestSite}=false;{CacheCodingOnUser}=true;{FileCacheEnabled}=false;{Lines.RemoveOrginal}=true;{Lines.ChangeType}=true;{ForwardTo}=true;{ForwardTo.NoPrevious}=true;{Lines.RemoveAll}=false;{Lang.All}=true;{Lines.UseLineTemplates}=true;{Lines.UseAsyncValidation}=true;{Labs.Vue}=true;{Labs.Vue.InAppSiteConfiguration}=true;{Labs.Vue.XChat}=false' : 'App.NAV.WS.xml?{DebugLog}=false;{FormsTestSite}=false;{PurchaseDisabled}=true;{UseNAVSSOEmailing}=true'
      this.dynamics = v.dynamics
    },
    handleUser(u) {
      this.user = u
    },
    handleChange(e) {
      this.value = e
      this.disable = false
    },
    handleToken(t) {
      this.token = t
    },
    hdldisable(v) {
      this.disable = true
      this.value = v
    },
    hdlhybrid(v) {
      this.value.hybridConnection = v
    },
    hdlLoad(v, m) {
      this.loading = v
      this.loadSettings = { animationStyle: 'slide', message: m }
    },
    hldcloseDeployment() {
      this.deploymentWindow = false
    },
    hdlToggle() {
      this.deploymentWindow = !this.deploymentWindow
    },
    hdlDeploymentInfo(j) {
      //needed to filter thomas response data - change later
      this.status.deploymentStatusUrl = j.deploymentStatusUrl
      this.status.correlationId = j.correlationId
      this.status.runId = j.runId;
      this.$router.push({ name: 'home' })
      let interval = setInterval(() => {
        this.$http('api/register/status', 'POST', this.token, this.status)
          .then(resp => {
            this.loading = false
            if (resp.status === 'Succeeded') {

                    let data = this.deploymentInfo.find(c => {
                      return c.correlationId == j.correlationId
                    })
                    if(resp.connectionString){
                      data.connectionString = resp.connectionString
                      data.status = resp.status
                    }else{
                      data.status = resp.status
                    } 
                    sessionStorage.setItem('deploymentInfo', JSON.stringify(this.deploymentInfo))
                    clearInterval(interval)
                    this.$toasted.global.success_message()
                    this.$router.push({ name: 'list' })
            } else if (resp.status === 'Failed' || resp.status === 'Suspended'|| resp.status === 'Canceled') {
               if (this.deploymentInfo.length > 0){
                let data = this.deploymentInfo.find(o => {
                  return o.correlationId == j.correlationId
                })
                data.status = resp.status
                sessionStorage.setItem('deploymentInfo', JSON.stringify(this.deploymentInfo))
              }
              clearInterval(interval)
              this.$toasted.global.error_message(
               {message:'Failed to send. Please try again'}
              )
            } else {
              //check if jobId exists
              if (this.deploymentInfo.length > 0) {
                //avoid duplications
                let checkJobId = this.deploymentInfo.some(i => i.correlationId == j.correlationId)
                if (!checkJobId) {
                  this.deploymentWindow = true
                  this.deploymentInfo.push({
                    correlationId: j.correlationId,
                    status: resp.status,
                    runId: j.runId,
                  })
                  sessionStorage.setItem('deploymentInfo', JSON.stringify(this.deploymentInfo))
                }
              } else {
                this.deploymentWindow = true
                this.deploymentInfo.push({
                  correlationId: j.correlationId,
                  deploymentStatusUrl: j.deploymentStatusUrl,
                  status: resp.status,
                  runId: j.runId,
                })
                sessionStorage.setItem('deploymentInfo', JSON.stringify(this.deploymentInfo))
              }
            }
          })
          .catch(e => {
            console.log(e)
            this.loading = false
            this.$toasted.global.error_message()
            clearInterval(interval)
          })
      }, 10000)
    },
  },
}
</script>

<style>
html { margin-left: calc(100vw - 100%); }
body #app{width: 100%; height: 100%;}
body {
  background-color: var(--o-bg);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  color: var(--o-text-on-bg1);
}
a{
  color: var(--o-text);
}
a:visited{
  color: var(--o-text);
}
.exception-wrapper{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: #0000002e;
  z-index: 100;
}
.loadform {
  position: fixed;
  top: 25px;
  z-index: 1000;
  left: 50%;
  margin-left: -110px;
  padding: 10px;
  max-width: 210px;
  background-color: var(--o-text-on-bg);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
/*Toast css*/
.toasted-container > .toasted.primary {
  font-size: 17px;
}
.fa-check-square {
  padding-right: 15px;
}
.action .fa-window-close {
  font-size: 17px;
  color: var(--o-text-on-bg);
}
.action .icon {
  align-self: flex-start;
  margin-top: 12px !important;
}
/*transition betweem components*/
.slide-enter-active {
  transition: all 1s;
}
.slide-leave-active {
  transition: opacity 0.3s ease-out;
}
.slide-enter {
  opacity: 0;
  transform: translateY(100px);
}
.slide-leave-to {
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


@media (min-width: 769px) {
  .exception-wrapper .exceptions{
    width: 600px;
    height: 600px;
    top: 50%;
    transform: translateY(-50%);
    position: relative;
  }
  .exception-list{
    max-height: 500px;
  }
}
/* .primary-btn{
  background-color:  var(--o-primary);
} */
/* css debug */
/* * {
  background: #000 !important;
  color: #0f0 !important;
  outline: solid #f00 1px !important;
} */
</style>
